import {
  FormInput,
  PaymentProcessorEnum,
  PrimaryButton,
  getPaymentProcessorTitle,
} from '@systemeio/ui'
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { paypalConnect } from 'modules/profile/payment-gateways/integrations/paypal-soap/api'
import { PaymentPaypalInterface } from 'modules/profile/payment-gateways/integrations/paypal-soap/types'
import { getPaypalHelpPageLink } from 'modules/profile/payment-gateways/integrations/paypal-soap/utils'
import React, { useState } from 'react'
import CreateModal from 'shared/components/create-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

const defaultValues: PaymentPaypalInterface = {
  username: '',
  password: '',
  signature: '',
}

const defaultErrors: PaymentPaypalInterface = {
  username: '',
  password: '',
  signature: '',
}

const PaypalCreateModal = () => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const { mutatePaymentIntegrations } = useConnectedPaymentIntegrations()
  const [errors, setErrors] = useState<PaymentPaypalInterface>(defaultErrors)
  const { user } = useUser()

  const onCreate = async (data: PaymentPaypalInterface) => {
    await fetchWithErrors(async () => {
      await paypalConnect(data)
      await mutatePaymentIntegrations()
    }, setErrors)
  }
  return (
    <>
      <PrimaryButton
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          setOpened(true)
        }}
        className={'font-bold'}
      >
        {t('dashboard.settings.payment_gateways.connect')}
      </PrimaryButton>
      <CreateModal
        fullCaption={t('dashboard.settings.payment_gateways.connect_payment_title', {
          payment: getPaymentProcessorTitle(PaymentProcessorEnum.PaypalSoap),
        })}
        opened={opened}
        onClose={() => setOpened(false)}
        needToast={false}
        additionalInfo={
          <HelpCenterLink
            link={getPaypalHelpPageLink(user?.dashboardLocale)}
            integration={getPaymentProcessorTitle(PaymentProcessorEnum.PaypalSoap)}
          />
        }
        defaultValues={defaultValues}
        creatable={[
          {
            field: 'username',
            onRender: (value, onChange) => (
              <FormInput
                key={'paypal-username-create'}
                label={t('global.username')}
                value={value}
                onChange={e => onChange(e.target.value)}
                error={errors.username}
              />
            ),
          },
          {
            field: 'password',
            onRender: (value, onChange) => (
              <FormInput
                key={'paypal-password-create'}
                label={t('global.password')}
                value={value}
                onChange={e => onChange(e.target.value)}
                error={errors.password}
              />
            ),
          },
          {
            field: 'signature',
            onRender: (value, onChange) => (
              <FormInput
                key={'paypal-signature-create'}
                label={t('dashboard.settings.payment_gateways.signature')}
                value={value}
                onChange={e => onChange(e.target.value)}
                error={errors.signature}
              />
            ),
          },
        ]}
        onCreate={onCreate}
        requiredFields={['username', 'password', 'signature']}
      />
    </>
  )
}

export default PaypalCreateModal
